module.exports = __webpack_public_path__ + "static/media/backgroundbutton.852943df.png";